const apiPath = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATH}`;
const assetHost =
  process.env.NODE_ENV === "development"
    ? "//staging.artthread.net"
    : window.location.origin;
const gaId = `${process.env.REACT_APP_GA_ID}`;
const captchaKey =
  process.env.REACT_APP_CAPTCHA_KEY || process.env.NEXT_PUBLIC_CAPTCHA_KEY;

export default {
  apiPath,
  assetHost,
  gaId,
  captchaKey,
};
